import { formatNumbers } from "../../lens-stats/formatters";

export const formatAdditionalInsightsValue = (value: number, units: string): string => {
    if (value === 0) {
        return "-";
    }

    return `${formatNumbers(Math.round(value))} ${units}`;
};
